import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MediaType } from '../../../types';
import { CloseButton } from './CloseButton';
export const PopinWrapper = ({ children, isFullScreen, mediaType, mediaUrl, closeButton, uid, oncePerSession, dialogId, labelledbyId, describedbyId, }) => {
    if (!children)
        return null;
    if (isFullScreen && (!mediaType || !mediaUrl)) {
        return null;
    }
    const dialogAttributes = {
        id: dialogId,
        'data-popin-id': uid,
        'data-only-once': oncePerSession,
        'data-dialog-id': dialogId,
        'aria-labelledby': labelledbyId,
        'aria-describedby': describedbyId,
    };
    // When popin is displayed, hidden class is removed and "flex" is added.
    if (isFullScreen === false) {
        return (_jsx("div", { ...dialogAttributes, className: "hidden fixed z-500 items-center justify-center md:items-end md:justify-end inset-0 bg-transparent pointer-events-none ", children: _jsx("div", { className: "md:absolute md:right-8 md:bottom-8 pointer-events-auto max-h-[100svh] overflow-y-auto", children: children }) }));
    }
    if (mediaType === MediaType.IMAGE && mediaUrl) {
        return (_jsxs("div", { ...dialogAttributes, className: "hidden fixed z-500 inset-0 items-start justify-center w-dvw h-dvh py-8 px-7.5 overflow-x-hidden overflow-y-auto overscroll-none bg-cover bg-center", style: { backgroundImage: `url(${mediaUrl})` }, children: [_jsx(CloseButton, { closeIconStyle: closeButton, dialogId: dialogId ?? '', small: true }), children] }));
    }
    if (mediaType === MediaType.VIDEO && mediaUrl) {
        return (_jsxs("div", { ...dialogAttributes, className: "hidden fixed z-500 inset-0 items-start justify-center w-dvw h-dvh py-8 px-7.5 overflow-x-hidden overflow-y-auto overscroll-none bg-white", children: [_jsxs("video", { className: "fixed inset-0 w-dvw h-dvh object-cover pointer-events-none", muted: true, autoPlay: true, loop: true, playsInline: true, "aria-hidden": "true", children: [_jsx("source", { src: `${mediaUrl}.mp4`, type: "video/mp4" }), _jsx("source", { src: `${mediaUrl}.webm`, type: "video/webm" })] }), _jsx(CloseButton, { closeIconStyle: closeButton, dialogId: dialogId ?? '', small: true }), children] }));
    }
    return null;
};
